import { createStore } from "redux";
import { frameRootReducer } from "../reducers";
import { FrameStore } from "../types";

export const createFrameStore = (): FrameStore => createStore(frameRootReducer);
